import { Button, Typography } from 'antd';

import type { NSendMessageModal } from '@app/features/SendoutCreationModal/components/SendMessageModal/SendMessageModal.types.ts';

const { Text } = Typography;

export const PointWithKeyWord: NSendMessageModal.PointWithKeyWord = ({
  componentKey,
  keyWord,
  description,
  addExtraTextToMessage,
  getDescriptionTag,
  isKeywordFormatting = false,
  type,
}): JSX.Element => {
  return (
    <Text key={componentKey}>
      <Button
        type="link"
        className="action-text-button"
        onClick={() => addExtraTextToMessage(keyWord, isKeywordFormatting)}
      >
        {keyWord}
      </Button>
      {' – '}
      {getDescriptionTag(description, isKeywordFormatting ? type : '')}.
    </Text>
  );
};
